import moment from 'moment'
import { FC, useCallback, useMemo } from 'react'

import { DATE_FORMATS } from '@/utils/dateHelpers'
import { useAppDispatch } from '@/utils/typeHelpers'
import {
  updateUserImportantDate,
  UserImportantDate,
} from '../userImportantDates.slice'
import { Text, List, Badge } from '@/ui'
import { TypographyStyles, TextColors, mtc } from '@/styles'

interface Props {
  userImportantDate: UserImportantDate
  indicateUnreadItems: boolean
}

export const ImportantDateListItem: FC<Props> = ({
  indicateUnreadItems,
  userImportantDate,
}) => {
  const dispatch = useAppDispatch()

  const isUnread = !userImportantDate.readAt
  const endDateCalc = userImportantDate.endsAt
    ? userImportantDate.endsAt
    : userImportantDate.actionItem.endsAt
  const subtitleText = useMemo(() => {
    const endDate = moment.utc(endDateCalc).format(DATE_FORMATS.DISPLAY_SHORT)

    if (userImportantDate.actionItem.startsAt) {
      const startDate = moment
        .utc(userImportantDate.actionItem.startsAt)
        .format(DATE_FORMATS.DISPLAY_SHORT)

      return `${startDate} - ${endDate}`
    }

    return endDate
  }, [endDateCalc, userImportantDate.actionItem.startsAt])

  const markAsRead = useCallback(() => {
    if (indicateUnreadItems) {
      dispatch(
        updateUserImportantDate(userImportantDate.id, {
          id: userImportantDate.id,
          readAt: Date.now(),
        })
      )
    }
  }, [dispatch, userImportantDate.id, indicateUnreadItems])

  return (
    <List.Item
      onClick={markAsRead}
      className={mtc(
        'p-4 border-b border-neutral-200',
        isUnread && indicateUnreadItems && 'bg-neutral-50 cursor-pointer'
      )}
    >
      <div className="flex flex-col space-y-1">
        <Text variant={TypographyStyles.BODY_SM}>
          {userImportantDate.actionItem.description}
          {indicateUnreadItems && isUnread && (
            <span className="inline-block align-middle ml-2">
              <Badge variant="secondary" color="green">
                NEW
              </Badge>
            </span>
          )}
        </Text>

        <Text variant={TypographyStyles.BODY_XS} color={TextColors.MOSS}>
          {subtitleText}
        </Text>
      </div>
    </List.Item>
  )
}
